import { Component } from "react";
import TopNav from "../components/top_nav";
import Footer from "../components/footer";
import { toast } from "react-toastify";
import { withRouter } from "../middlewares/with_router";
import positions from "../databases/careers_db";
import JobApplicationService from "../services/job_application_service";

class JobApplyFormScreen extends Component {
    state = {
        job: null,
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
        jobDetails: "",
        coverLetter: null,
        resume: null,
        otherDocs: null,
        loading: false,
    };

    componentDidMount() {
        const jobId = parseInt(this.props.params.id, 10);
        const job = positions.find((job) => job.id === jobId);
        this.setState({ job });
    }

    handleChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    };

    handleFileChange = (e) => {
        this.setState({ [e.target.id]: e.target.files[0] });
    };

    isFormValid = () => {
        const { firstName, lastName, email, phone, message, resume, job } = this.state;
        return firstName && lastName && email && phone && message && resume && job;
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        const {
            firstName,
            lastName,
            email,
            phone,
            message,
            coverLetter,
            resume,
            otherDocs,
            job
        } = this.state;

        this.setState({ loading: true });

        const formData = new FormData();
        formData.append("firstName", firstName);
        formData.append("lastName", lastName);
        formData.append("email", email);
        formData.append("phone", phone);
        formData.append("message", message);
        formData.append("jobDetails", job ? job.title : "");
        formData.append("coverLetter", coverLetter); // These names must match multer field names
        formData.append("resume", resume);
        if (otherDocs) {
            formData.append("otherDocs", otherDocs);
        }

        try {
            const response = await JobApplicationService.applyJob(formData);

            if (response.status === 200) {
                toast.success("Message sent successfully!");
                this.setState({
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    message: "",
                    coverLetter: null,
                    resume: null,
                    otherDocs: null,
                });

                document.getElementById("coverLetter").value = "";
                document.getElementById("resume").value = "";
                document.getElementById("otherDocs").value = "";
            } else {
                toast.error("Failed to send message.");
            }
        } catch (error) {
            console.error("Submit error:", error);
            toast.error("Something went wrong.");
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const {
            job,
            firstName,
            lastName,
            email,
            phone,
            message,
            loading,
        } = this.state;

        if (!job) return <div className="text-center py-5">Loading job details...</div>;

        return (
            <div>
                <TopNav />
                <div className="container my-5">
                    <div className="row justify-content-center mb-4">
                        <div className="text-center fs-52">Application form</div>
                        <div className="text-center fs-16">It will take you approximately 2-4 minutes to complete this application.</div>
                    </div>
                    <div className="row rounded-4 shadow-sm p-4 p-md-5">
                        <div className="col-md-6 pe-md-5 mb-4 mb-md-0">
                            <h5 className="text-muted fs-18 mb-2">You're applying for the position</h5>
                            <h2 className="fw-bold mb-4 fs-32">{job.title}</h2>
                            <ul className="list-unstyled fs-16 text-primary-blue">
                                <li><strong>Location:</strong> {job.location}</li>
                                <li><strong>Role:</strong> {job.type}</li>
                                <li><strong>Experience:</strong> {job.experience}</li>
                                <li><strong>Industry:</strong> {job.industry}</li>
                                <li><strong>Department:</strong> {job.department}</li>
                            </ul>
                        </div>

                        {/* Application Form */}
                        <div className="col-md-6">
                            <h4 className="fw-semibold mb-4 fs-28">Personal Information</h4>
                            <form onSubmit={this.handleSubmit}>
                                <div className="d-flex flex-column flex-md-row gap-3">
                                    <div className="mb-4 flex-grow-1">
                                        <label htmlFor="firstName" className="form-label">First Name <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            id="firstName"
                                            value={firstName}
                                            onChange={this.handleChange}
                                            className="form-control rounded-pill bg-black-05 border-black-20 py-2 px-20px mt-1"
                                            placeholder="First name"
                                        />
                                    </div>
                                    <div className="mb-4 flex-grow-1">
                                        <label htmlFor="lastName" className="form-label">Last Name <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            id="lastName"
                                            value={lastName}
                                            onChange={this.handleChange}
                                            className="form-control rounded-pill bg-black-05 border-black-20 py-2 px-20px mt-1"
                                            placeholder="Last name"
                                        />
                                    </div>
                                </div>

                                <div className="d-flex flex-column flex-md-row gap-3">
                                    <div className="mb-4 flex-grow-1">
                                        <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                                        <input
                                            type="email"
                                            id="email"
                                            value={email}
                                            onChange={this.handleChange}
                                            className="form-control rounded-pill bg-black-05 border-black-20 py-2 px-20px mt-1"
                                            placeholder="Email"
                                        />
                                    </div>
                                    <div className="mb-4 flex-grow-1">
                                        <label htmlFor="phone" className="form-label">Phone Number <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            id="phone"
                                            value={phone}
                                            onChange={this.handleChange}
                                            className="form-control rounded-pill bg-black-05 border-black-20 py-2 px-20px mt-1"
                                            placeholder="Phone Number"
                                        />
                                    </div>
                                </div>



                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="resume" className="form-label">Resume <span className="text-danger">*</span></label>
                                        <label htmlFor="resume" className="btn btn-outline-primary-blue w-100 rounded-pill d-flex justify-content-center align-items-center text-truncate">
                                            {this.state.resume ? this.state.resume.name : "Resume"}
                                            <i className="bi bi-link-45deg ms-2"></i>
                                        </label>
                                        <input
                                            id="resume"
                                            type="file"
                                            onChange={this.handleFileChange}
                                            className="d-none"
                                        />
                                    </div>

                                    <div className="col-md-6 mb-4">
                                        <label htmlFor="coverLetter" className="form-label">Cover Letter</label>
                                        <label htmlFor="coverLetter" className="btn btn-outline-primary-blue w-100 rounded-pill d-flex justify-content-center align-items-center">
                                            {this.state.coverLetter ? this.state.coverLetter.name : "Cover Letter"}
                                            <i className="bi bi-link-45deg ms-2"></i>
                                        </label>
                                        <input
                                            id="coverLetter"
                                            type="file"
                                            onChange={this.handleFileChange}
                                            className="d-none"
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="mb-4 col-md-6">
                                        <label htmlFor="otherDocs" className="form-label">Other</label>
                                        <label htmlFor="otherDocs" className="btn btn-outline-primary-blue w-100 rounded-pill d-flex justify-content-center align-items-center">
                                            {this.state.otherDocs ? this.state.otherDocs.name : "Other Documents"}
                                            <i className="bi bi-link-45deg ms-2"></i>
                                        </label>
                                        <input
                                            id="otherDocs"
                                            type="file"
                                            onChange={this.handleFileChange}
                                            className="d-none"
                                        />
                                    </div>

                                </div>



                                {/* <div className="d-flex flex-column flex-md-row gap-3">
                                    <div className="mb-4">
                                        <label htmlFor="coverLetter" className="form-label">Cover Letter *</label>
                                        <input
                                            id="coverLetter"
                                            type="file"
                                            onChange={this.handleFileChange}
                                            className="form-control"
                                        />
                                    </div>

                                    <div className="mb-4">
                                        <label htmlFor="resume" className="form-label">Resume *</label>
                                        <input
                                            id="resume"
                                            type="file"
                                            onChange={this.handleFileChange}
                                            className="form-control"
                                        />
                                    </div>
                                </div>


                                <div className="mb-4">
                                    <label htmlFor="otherDocs" className="form-label">Other Documents</label>
                                    <input
                                        id="otherDocs"
                                        type="file"
                                        onChange={this.handleFileChange}
                                        className="form-control"
                                    />
                                </div> */}

                                <div className="mb-4">
                                    <label htmlFor="message" className="form-label">Message <span className="text-danger">*</span></label>
                                    <textarea
                                        id="message"
                                        value={message}
                                        onChange={this.handleChange}
                                        className="form-control rounded-4 bg-black-05 border-black-20"
                                        rows="8"
                                        placeholder="Add a message or anything else you want to share"
                                    ></textarea>
                                </div>

                                <button
                                    type="submit"
                                    className="btn w-100 py-3 text-white rounded-3 fs-14"
                                    style={{ backgroundColor: "#193E6C" }}
                                    disabled={!this.isFormValid() || loading}
                                >
                                    {loading ? "Sending..." : "Submit request"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(JobApplyFormScreen);
